import request from 'checkout/utils/axios'

export const applyCoupon = async code => {
  const response = await request
    .post('/coupon', { couponCode: code })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })
  return response
}

export const removeCoupon = async code => {
  const response = await request
    .delete('/coupon', { couponCode: code })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })
  return response
}
